import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketSolution } from '../../../../core/models/ticket.model';
import { FeedbackService, FeedbackData } from '../../../../core/services/feedback.service';

@Component({
  selector: 'app-solution-sidebar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      *ngIf="solution"
      class="fixed inset-0 overflow-hidden"
      aria-labelledby="slide-over-title"
      role="dialog"
      aria-modal="true"
    >
      <div class="absolute inset-0 overflow-hidden">
        <div class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
        <div class="fixed inset-y-0 right-0 pl-10 max-w-full flex">
          <div class="w-screen max-w-xs sm:max-w-sm md:max-w-md">
            <div class="h-full flex flex-col bg-white shadow-xl">
              <div class="p-4 sm:p-6">
                <h2 class="text-lg font-medium text-gray-900">Suggested Solution</h2>
                <div class="mt-4">
                  <p class="text-sm text-gray-500">Type: {{ solution.type }}</p>
                  <p class="mt-2">{{ solution.content }}</p>
                  <div class="mt-6 flex space-x-4">
                    <button
                      (click)="onAccept()"
                      class="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700"
                    >
                      Accept & Close
                    </button>
                    <button
                      (click)="onReject()"
                      class="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                    >
                      Continue with Ticket
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class SolutionSidebarComponent {
  @Input() solution: TicketSolution | null = null;
  @Input() ticketTitle: string = '';
  @Input() ticketDescription: string = '';
  @Input() ticketPriority: string = '';
  
  @Output() accept = new EventEmitter<void>();
  @Output() reject = new EventEmitter<void>();

  private startTime: number = 0;

  constructor(private feedbackService: FeedbackService) {
    this.startTime = Date.now();
  }

  onAccept(): void {
    this.submitFeedback(true);
    this.accept.emit();
  }

  onReject(): void {
    this.submitFeedback(false);
    this.reject.emit();
  }

  private submitFeedback(satisfied: boolean): void {
    if (!this.solution) return;
    
    const duration = Math.floor((Date.now() - this.startTime) / 1000); // in seconds
    
    const feedbackData: FeedbackData = {
      history: [
        {
          question: this.ticketDescription,
          answer: this.solution.content,
          timestamp: new Date().toISOString()
        }
      ],
      satisfied: satisfied,
      duration: duration,
      subject: this.ticketTitle,
      description: this.ticketDescription,
      priority: this.ticketPriority
    };

    this.feedbackService.submitFeedback(feedbackData).subscribe({
      next: () => console.log('Feedback submitted successfully'),
      error: (error) => console.error('Error submitting feedback', error)
    });
  }
}
